import { useState } from "react";
import { MdFilterList, MdOutlineRemoveRedEye } from "react-icons/md";
import ButtonElement from "../../Common/ButtonElement";
import TableComponent from "../components/TableComponent";
import SearchBox from "../components/SearchComponent";
import NewOrders from "../Quotation/components/QuotationGenerate";
import AddCompany from "../CompanyPage/components/AddCompany";
import { TiPencil } from "react-icons/ti";

const sampleColumns = [
    "Order Id", "Company Name", "Order Date", "Quantity", "Payment", "Status", "Action"
];

const sampleData = [
    { orderId: "123", companyName: "XYZ", orderDate: "20/02/25", quantity: "10", payment: "Unpaid", status: "Pending" },
    { orderId: "123", companyName: "XYZ", orderDate: "20/02/25", quantity: "10", payment: "Unpaid", status: "Pending" },
    { orderId: "123", companyName: "XYZ", orderDate: "20/02/25", quantity: "10", payment: "Unpaid", status: "Pending" },
    { orderId: "123", companyName: "XYZ", orderDate: "20/02/25", quantity: "10", payment: "Unpaid", status: "Pending" },
    { orderId: "123", companyName: "XYZ", orderDate: "20/02/25", quantity: "10", payment: "Unpaid", status: "Pending" },
    { orderId: "123", companyName: "XYZ", orderDate: "20/02/25", quantity: "10", payment: "Unpaid", status: "Pending" },
    { orderId: "123", companyName: "XYZ", orderDate: "20/02/25", quantity: "10", payment: "Unpaid", status: "Pending" },
    { orderId: "123", companyName: "XYZ", orderDate: "20/02/25", quantity: "10", payment: "Unpaid", status: "Pending" },
    { orderId: "123", companyName: "XYZ", orderDate: "20/02/25", quantity: "10", payment: "Unpaid", status: "Pending" },
    { orderId: "123", companyName: "XYZ", orderDate: "20/02/25", quantity: "10", payment: "Unpaid", status: "Pending" },
    { orderId: "123", companyName: "XYZ", orderDate: "20/02/25", quantity: "10", payment: "Unpaid", status: "Pending" },
    { orderId: "123", companyName: "XYZ", orderDate: "20/02/25", quantity: "10", payment: "Unpaid", status: "Pending" }
]

const Orders = () => {
    const [state, setState] = useState({
        showOrder: false,
        addCompany: false
    });

    const { showOrder, addCompany } = state;
    return <div className="orders-container">
        <SearchBox placeholder="Search here..." className="mb-3" />
        <TableComponent title={"Orders"} headers={sampleColumns} data={sampleData} nextAction={() => { }} prevAction={() => { }} prevRequest={false} nextRequest={false} current={1} total={60} render={(tdData, index) => <tr key={index}>
            <td>{(index ?? 0) + 1}</td>
            <td>{tdData?.orderId ?? "-"}</td>
            <td>{tdData?.companyName ?? "-"}</td>
            <td>{tdData?.orderDate ?? "-"}</td>
            <td>{tdData?.quantity ?? "-"}</td>
            <td>{tdData?.payment ?? "-"}</td>
            <td>{tdData?.status ?? "-"}</td>
            <td>
                <div className="action d-flex justify-content-center align-items-center px-3">
                    <ButtonElement text={<MdOutlineRemoveRedEye size={20} />} cssClass="more-radius mx-1 px-4" onClick={() => { }} variant="btn-outline-preview" loading={false} />
                    <ButtonElement text={<TiPencil size={20} />} cssClass="more-radius mx-1 px-4" onClick={() => setState(prev => ({ ...prev, addInstaller: true, installerData: tdData }))} variant="btn-outline-edit" loading={false} />
                </div>
            </td>
        </tr>} FilterComponent={<>
            <ButtonElement text={<span className="d-flex justify-content-center align-items-center"><MdFilterList size={20} className="me-1" />Filter</span>} cssClass="small-radius me-1 mb-1" onClick={() => { }} variant="btn-outline-grey" loading={false} />

            <ButtonElement text={"New Order"} cssClass="small-radius me-1 mb-1" onClick={() => setState(prev => ({ ...prev, showOrder: true }))} variant="btn-black" loading={false} />
        </>} />

        {showOrder ? <NewOrders show={showOrder} hideModal={() => setState(prev => ({ ...prev, showOrder: false }))} showCompany={() => setState(prev => ({ ...prev, showOrder: false, addCompany: true }))} /> : null}
        {addCompany ? <AddCompany show={addCompany} hideModal={() => setState(prev => ({ ...prev, addCompany: false }))} /> : null}
    </div>
}

export default Orders;